import React, { Fragment } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { useLocation } from "@reach/router";
import { Row } from "../../internal/Header/Styles";
import { LogoutIcon, LogoutText } from "../../internal/Header/Styles";

const MenuBurger = ({
  actions = [],
  breadcrumbs = [],
  onBreadcrumbClick = () => {},
  paymentPage = false,
  actions_input,
  color,
  hoverColor,
  menuBackgroundColor,
  activeMenuButtonBgColor,
  activeMenuButtonTextColor,
  menuButtonBgColor,
  handleLogout = () => {},
  signOut = false,
  align = false,
}) => {
  const location = useLocation();

  return (
    <ActionBarContainer actions={actions} {...{ signOut, align }}>
      <Breadcrumbs>
        {actions
          .filter((item) => !item.hidden)
          .map((breadcrumb, index) => (
            <Fragment key={`breadcrumb-${breadcrumb}-${index}`}>
              <Breadcrumb
                onClick={() => breadcrumb.props.onClick()}
                textColor={
                  location.hash.includes(breadcrumb?.text?.toLowerCase())
                    ? activeMenuButtonTextColor
                    : color
                }
                // style={{
                //   backgroundColor: location.hash.includes(
                //     breadcrumb.text.toLowerCase(),
                //   )
                //     ? activeMenuButtonBgColor
                //     : menuButtonBgColor,
                // }}
                hoverColor={hoverColor}
              >
                {breadcrumb.text}
              </Breadcrumb>
              <Breadcrumb> </Breadcrumb>
            </Fragment>
          ))}
      </Breadcrumbs>
      {signOut && (
        <Row onClick={handleLogout}>
          <LogoutIcon src={require("../../../assets/images/logout.svg")} />
          <LogoutText>{"Sign Out"}</LogoutText>
        </Row>
      )}
    </ActionBarContainer>
  );
};

export default MenuBurger;

const ActionBarContainer = styled.div`
  margin: 0px 15px 0px 15px;
  display: flex;
  flex-direction: column-reverse;
  min-height: ${({ actions }) => (actions.length === 0 ? "0" : "35px")};
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
  margin: 0;
  padding: 0px 53px 10px 10px;
  @media ${theme?.breakpoints?.sm_up} {
    height: ${({ signOut, align }) => (signOut || align ? "55px" : "35px")};
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 35px 0 35px;
    margin: 0;
    border-bottom: 1px solid ${COLORS.BORDER_GREY};
  }
`;

const Breadcrumbs = styled.div``;

const Breadcrumb = styled.span`
  margin-right: 4px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  color: ${({ textColor }) => textColor || "#ffffff"};
  font-family: ${theme.fonts.primaryFontExtraBold};
  &:hover {
    color: ${({ hoverColor }) => hoverColor || "red"};
  }

  @media ${theme?.breakpoints?.sm_up} {
    font-size: 14px;
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
`;
